export const FETCH_ACTION_TILES = 'FETCH_ACTION_TILES';
export const FETCH_ACTION_TILES_SUCCESS = 'FETCH_ACTION_TILES_SUCCESS';
export const FETCH_ACTION_TILES_ERROR = 'FETCH_ACTION_TILES_ERROR';

export const fetchActionTiles = () => ({ type: FETCH_ACTION_TILES });
export const fetchActionTilesSuccess = (payload: any) => ({ type: FETCH_ACTION_TILES_SUCCESS, payload });
export const fetchActionTilesError = (payload: any) => ({ type: FETCH_ACTION_TILES_ERROR, payload });
